import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import ApiURL from "../../../api/ApiURL";
import cogoToast from "cogo-toast";
import PageTitle from '../../home/PageTitle';
import dayjs from "dayjs";

class OtherSubBooking extends Component {
    //Constructor
    constructor(props) {
        super(props);
        this.state = {
            tcData: props.tcData || [],
            locationData: props.locationData || [],
            charges: props.otherChargeData || [],
            subBookingId: props.subBookingId || 0,
            subBookingNo: props.subBookingNo || '',
            subBookingType: props.subBookingType || 'Other',
            bookingId: props.bookingId,
            travelCircuitId: props.travelCircuitId || 0,
            locationId: props.locationId || 0,
            chargeId: props.chargeId || 0,
            chargeDescription: props.ChargeDescription || '',
            checkInDate: props.checkInDate || '',
            checkOutDate: props.checkOutDate || '',
            comment: props.comment || '',
            payableAmount: props.payableAmount || 0,
            paidAmount: props.paidAmount || 0,
            dueAmount: props.dueAmount || 0,
            userId: props.userId || 1,
            isActive: props.isActive || true,
        };
    }
    //ComponentDidMount
    componentDidMount() {
        this.getAllAdditionalChargeData();
    }
    //ComponentDidUpdate
    componentDidUpdate(prevProps) {
        const prevPropsString = JSON.stringify(prevProps);
        const currentPropsString = JSON.stringify(this.props);

        if (prevPropsString !== currentPropsString) {
            // Update state with new props
            this.setState({
                ...this.state,
                tcData: this.props.tcData,
                locationData: this.props.locationData,
                charges: this.props.otherChargeData,
                subBookingId: this.props.subBookingId,
                subBookingNo: this.props.subBookingNo,
                subBookingType: this.props.subBookingType,
                bookingId: this.props.bookingId,
                travelCircuitId: this.props.travelCircuitId,
                locationId: this.props.locationId,
                chargeId: this.props.chargeId,
                checkInDate: this.props.checkInDate,
                checkOutDate: this.props.checkOutDate,
                comment: this.props.comment,
                payableAmount: this.props.payableAmount,
                paidAmount: this.props.paidAmount,
                dueAmount: this.props.dueAmount,
                userId: this.props.userId,
                isActive: this.props.isActive,
            });
        }
    }
    //OnChangeHandler
    onChangeHandler = (e) => {
        this.props.subBookingHandler(e);
    }
    //GetAllAdditionalChargeData
    getAllAdditionalChargeData = () => {
        axios
            .get(ApiURL.GetAllAdditionalCharge)
            .then((response) => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    var dataResult = respData.DataResult;
                    this.setState({ ...this.state, charges: dataResult });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                }
            })
            .catch((error) => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            });
    }
    //Reset Fields
    resetFields = () => {
        this.setState({
            subBookingId: 0,
            subBookingNo: '',
            subBookingType: '',
            bookingId: 0,
            chargeId: 0,
            checkInDate: '',
            checkOutDate: '',
            comment: '',
            payableAmount: 0,
            paidAmount: 0,
            dueAmount: 0,
            isActive: true
        })
    }
    //OnChangeHandler
    closeModal = () => {
        this.resetFields();
        this.props.closeModal();
    }
    //OnChangeHandler
    onChangeHandler = (e) => {
        this.props.subBookingHandler(e);
    }
    //Save Sub-Booking
    saveSubBooking = (e) => {
        e.preventDefault();

        if (this.state.travelCircuitId === 0) {
            cogoToast.error("Travel Circuit is required!", { position: "bottom-center" });
        }
        else if (this.state.locationId === 0) {
            cogoToast.error("Location is required!", { position: "bottom-center" });
        }
        else if (this.state.chargeId === 0) {
            cogoToast.error("Other charge is required!", { position: "bottom-center" });
        }
        else if (this.state.checkInDate === '') {
            cogoToast.error("From date is required!", { position: "bottom-center" });
        }
        else if (this.state.checkOutDate === '') {
            cogoToast.error("To date is required!", { position: "bottom-center" });
        }
        else if (this.state.payableAmount === '' || this.state.payableAmount === 0) {
            cogoToast.error("Vendor payable amount is required!", { position: "bottom-center" });
        }
        else {
            let selectedTravelCircuitId = parseInt(this.state.travelCircuitId);
            let selectedLocationId = parseInt(this.state.locationId);
            let selectedChargeId = parseInt(this.state.chargeId);
            const selectedTravelCircuitName = this.state.tcData.find(v => v.TravelCircuitId === selectedTravelCircuitId)?.TravelCircuitName;
            const selectedLocationName = this.state.locationData.find(v => v.LocationId === selectedLocationId)?.LocationName;
            const selectedChargeDescription = this.state.charges.find(v => v.ChargeId === selectedChargeId)?.ChargeDescription;
            //const selectedBookingNo = this.state.subBookingNo != '' ? this.state.subBookingNo : dayjs(new Date()).format('DDMMYYhhmmss');

            let subBooking = {
                SubBookingId: this.state.subBookingId,
                SubBookingNo: '',
                SubBookingType: this.state.subBookingType,                
                VendorName: selectedChargeDescription,
                BookingId: this.state.bookingId,
                TravelCircuitId: selectedTravelCircuitId,
                TravelCircuitName: selectedTravelCircuitName,
                LocationId: selectedLocationId,
                LocationName: selectedLocationName,
                ChargeId: this.state.chargeId,
                CheckInDate: this.state.checkInDate,
                CheckOutDate: this.state.checkOutDate,
                Comment: this.state.comment,
                PayableAmount: parseFloat(this.state.payableAmount),
                PaidAmount: this.state.paidAmount,
                DueAmount: this.state.dueAmount,
                UserId: this.state.userId,
                IsActive: true
            };

            //API call to save individual sub-booking data
            axios
                .post(ApiURL.SaveSubBooking, subBooking)
                .then((response) => {
                    let respData = response.data;
                    console.log(respData);
                    if (respData.StatusCode === 200) {
                        cogoToast.success(respData.Message, { position: "bottom-center" });
                        let sbData = respData.DataResult;
                        if (sbData !== null) {
                            subBooking.SubBookingId = sbData.SubBookingId;
                            subBooking.SubBookingNo = sbData.SubBookingNo;
                            this.props.addSubBookings(subBooking);
                            this.closeModal();
                        }
                    }
                    else if (respData.StatusCode === 300 || respData.StatusCode === 400 || respData.StatusCode === 404) {
                        cogoToast.warn(respData.Message, { position: "bottom-center" });
                    }
                    else if (respData.StatusCode === 500) {
                        cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    }
                })
                .catch((error) => {
                    cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
                });
        }
    }
    render() {
        const { tcData, locationData, travelCircuitId, locationId, subBookingNo, charges, chargeId, checkInDate, checkOutDate,
            comment, payableAmount, paidAmount, dueAmount } = this.state;
        return (
            <>
                {/* <!-- Hotel modal section--> */}
                <div className={this.props.showModal === true ? "modal show-modal  modalWrapper" : "modal"}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">
                                    Manage {this.props.subBookingType} Sub-Booking
                                    {subBookingNo !== '' ? ' ['+subBookingNo+'] ' : ''}
                                </h3>
                                <i className="fa-regular fa-circle-xmark text-danger" onClick={this.closeModal}></i>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <form>
                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <label className="form-label">Travel Circuit <span className='text-danger'>*</span></label>
                                                <select
                                                    name="travelCircuitId"
                                                    value={travelCircuitId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {tcData.map((item, index) => (
                                                        <option key={index} value={item.TravelCircuitId}>
                                                            {item.TravelCircuitName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Location <span className='text-danger'>*</span></label>
                                                <select
                                                    name="locationId"
                                                    value={locationId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {locationData.map((item, index) => (
                                                        <option key={index} value={item.LocationId}>
                                                            {item.LocationName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">Other Charges <span className='text-danger'>*</span></label>
                                                <select
                                                    name="chargeId"
                                                    value={chargeId}
                                                    className="form-control-sm border border-primary form-select w-100"
                                                    onChange={this.onChangeHandler}
                                                >
                                                    <option value="0">-- Select --</option>
                                                    {charges.map((item, index) => (
                                                        <option key={index} value={item.ChargeId}>
                                                            {item.ChargeDescription}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">From Date <span className='text-danger'>*</span></label>
                                                <input type="date" name="checkInDate" className="form-control border border-secondary" value={checkInDate} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label">To Date <span className='text-danger'>*</span></label>
                                                <input type="date" name="checkOutDate" className="form-control border border-secondary" value={checkOutDate} onChange={this.onChangeHandler} />
                                            </div>
                                            <div className="col-md-12">
                                                <label className="form-label">Comments</label>
                                                <textarea
                                                    name="comment"
                                                    className="form-control border border-secondary"
                                                    rows="2"
                                                    value={comment}
                                                    onChange={this.onChangeHandler}></textarea>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card mb-1 mt-2">
                                <div className="card-head text-center">Vendor Payment</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-label">Vendor Payable <span className='text-danger'>*</span></label>
                                            <input type="number" name="payableAmount" className="form-control-sm border border-primary w-100" value={payableAmount} onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Paid to Vendor</label>
                                            <input type="number" name="paidAmount" className="form-control-sm border border-primary w-100" value={paidAmount} disabled onChange={this.onChangeHandler} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Due to Vendor</label>
                                            <input type="number" name="dueAmount" className="form-control-sm border border-primary w-100" value={dueAmount} disabled onChange={this.onChangeHandler} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer my-3">
                                <button className="btn btn-success button-box-shadow" onClick={this.saveSubBooking}>
                                    <i className="fa-solid fa-circle-check"></i> Save
                                </button>

                                <button className="btn btn-secondary button-box-shadow" onClick={this.closeModal}>
                                    <i className="fa-solid fa-circle-xmark"></i> Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Hotel modal section--> */}
            </>
        );
    }
}

export default OtherSubBooking;